import React from "react";
import { Link } from "react-router-dom";

const AlbumDesign2 = () => {
  return (
    <div className="mx-5">
      {/* --------Second Carousel----------- */}
      <div className="row justify-content-center align-items-center my-5">
        <div className="col-md-4 pe-5">
          <h2 className="prata-regular mb-4">Classic & Modern</h2>
          <p>
            <b>Classic :</b> Our most popular style, using white or black
            backgrounds. Images are placed cleanly without borders or
            overlaps—focus is entirely on the images.
          </p>
          <p>
            <b>Modern :</b> Similar to “Classic” but includes subtle objects,
            detail images as backgrounds, and thin outlines.
          </p>
        </div>

        <div className="col-md-8">
          <div
            id="carouselContemporary1"
            className="carousel slide"
            data-bs-ride="carousel"
            data-bs-interval="2000"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src="/images/1 (4).png"
                  className="d-block w-100"
                  style={{ height: "400px", objectFit: "cover" }}
                  alt="Contemporary Album"
                />
              </div>
              <div className="carousel-item">
                <img
                  src="/images/1 (5).png"
                  className="d-block w-100"
                  style={{ height: "400px", objectFit: "cover" }}
                  alt="Elegant Album"
                />
              </div>
              <div className="carousel-item">
                <img
                  src="/images/1 (6).png"
                  className="d-block w-100"
                  style={{ height: "400px", objectFit: "cover" }}
                  alt="Elegant Album"
                />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselContemporary1"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselContemporary1"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlbumDesign2;
